import React from 'react';
import CustomAddPage from 'components/custom-pages/CustomAddPage';

const Add = ({ data, handleClick }) => {
  const initialValues = {
    reason: data?.reason || '',
  };

  const inputFields = [
    {
      name: 'reason',
      label: 'Scrap Reason',
      type: 'text',
      required: true,
    },
  ];

  return (
    <CustomAddPage
      pageTitle={
        data ? 'Update Scrap Reason' : 'Add Scrap Reason'
      }
      url={'scrap-reason'}
      action={!data ? 'create' : 'update'}
      updateId={data?._id}
      queryKey="scrap-reason"
      inputFields={inputFields}
      data={initialValues}
      handleClick={handleClick}
    />
  );
};

export default Add;
